import { Link } from "react-router-dom";

import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import useQualifyBOM from "../../hooks/useQualifyBOM";
import { useBomContext } from "./BOMContext";

export default function UnsubmittedActions() {
  const { bom } = useBomContext();
  const { qualify } = useQualifyBOM(bom?.BOMID);

  if (!bom) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <LoadingSpinner />
      </div>
    );
  }
  return (
    <div>
      <div className="d-flex justify-content-center align-items-center gap-2">
        <Link className="btn btn-outline-primary fw-bold text-uppercase" to="/dashboard">
          Cancel & Go Back
        </Link>
        <button onClick={() => qualify()} type="button" className="btn btn-primary fw-bold text-uppercase">
          Continue
        </button>
      </div>
    </div>
  );
}
